import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import AzureResourceGroupPicker, {
  AzureResourceGroupPickerFieldSchema,
} from './AzureResourceGroupPickerExtension';
import { validateAzureResourceGroup } from './validator';

export const azureResourceGroupPickerField = {
  name: 'AzureResourceGroupPicker',
  component: AzureResourceGroupPicker,
  schema: AzureResourceGroupPickerFieldSchema,
  validation: validateAzureResourceGroup,
};

export const AzureResourceGroupPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    ...azureResourceGroupPickerField,
    schema: AzureResourceGroupPickerFieldSchema.schema,
  }),
);
